import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DataAppContext = React.createContext();

const DataApp = (props) => {
    const initialValues = { loginstatus: false, username: 'User 1', showmenu: false, bgColor: 'white', leftPanelVisible: true }
    const [appstate, setAppState] = useState(initialValues);
    const navigate = useNavigate();

    const checkLogin = () => {
        let token = localStorage.getItem('jwttoken');
        if (token) {
            setAppState({ ...appstate,showmenu: true, loginstatus: true, leftPanelVisible: true });
        }
        else {
            setAppState({ ...appstate, loginstatus: false,showmenu: false,leftPanelVisible: false });
        }
    }

    useEffect(() => {
        checkLogin();
    }, [])

    const login = () => {
        setAppState({ ...appstate, loginstatus: !appstate.loginstatus });
    }
    const login_user = () => {
        setAppState({ ...appstate, loginstatus: true, leftPanelVisible: true });
    }
    const logout_user = () => {
        localStorage.removeItem('jwttoken');
        localStorage.removeItem('userid');
        localStorage.removeItem('usertype');
        setAppState({ ...appstate, loginstatus: false, showmenu: false, leftPanelVisible: false });
        navigate('/login');
    }

    const showhidemenu = () => {
        setAppState({ ...appstate, showmenu: !appstate.showmenu });
    }

    const toggleLeftPanel = () => {
        setAppState({ ...appstate, leftPanelVisible: !appstate.leftPanelVisible });
    }
    return (
        <DataAppContext.Provider value={{ appstate, login, login_user, logout_user, showhidemenu, toggleLeftPanel }}>
            <div className='app-wrapper'>
                {props.children}
            </div>
        </DataAppContext.Provider>
    )
}

export default DataApp;

export { DataAppContext };